import React, { useEffect } from 'react';

import { useTenantUserSettings } from '@eluve/frontend-feature-user-settings';
import { useRecordingSounds } from '@eluve/frontend-machine-common';
import { sessionSoundPlayer } from '@eluve/sounds';

import { useTranscriptionMachineActor } from '../hooks/useTranscriptionMachine';

export const TranscriptionSounds: React.FC = () => {
  const { settings } = useTenantUserSettings();
  const soundsEnabled = settings?.enableSoundEffects ?? true;
  const machine = useTranscriptionMachineActor();

  useEffect(() => {
    sessionSoundPlayer.setIsEnabled(soundsEnabled);
  }, [soundsEnabled]);

  useRecordingSounds({
    enableSounds: soundsEnabled,
    machine,
    soundPlayer: sessionSoundPlayer,
  });

  return null;
};
